export default "__VITE_ASSET__WNAl7SYu__"